import { TreeViewComponent } from "@syncfusion/ej2-react-navigations";
import { Suspense, lazy, useState } from "react";
import { useSearchParams } from "react-router-dom";
import FormflowsWrapper from "./formFlowWrapper";

const Workflows = lazy(() => import("../../SpaceSettings/UserAdministration/Workflows/WorkflowsWrapper"));
const GroupsInSpace = lazy(() => import("../../SpaceSettings/UserAdministration/SpaceUsers/GroupsInSpace"));

function Settings({ workspaceId, projectId }) {
  const [selected, setSelected] = useState("workflows");

  const [urlSearchParams] = useSearchParams();
  const workflowId = urlSearchParams.get("workflowId");

  const dataSource = [
    {
      code: "userAdministration",
      name: "User Administration",
      selectable: false,
      expanded: true,
      child: [
        { code: "workflows", name: "Review Flows", selected: true },
        { code: "formFlows", name: "Form Flows" },
        { code: "groups", name: "Groups " },
      ],
    },
  ];

  const nodeSelected = (args) => {
    setSelected(args.nodeData.id);
  };

  return (
    <div className="flex border-t border-system_colour_44 h-full w-full overflow-auto">
      <TreeViewComponent
        nodeSelected={nodeSelected}
        className="flex-none w-56"
        fields={{
          dataSource,
          id: "code",
          text: "name",
          child: "child",
        }}
      />
      <div className="overflow-auto w-full">
        {selected == "workflows" && (
          <Suspense>
            <Workflows spaceId={workspaceId} projectId={projectId} workflowId={workflowId} />
          </Suspense>
        )}
        {selected == "formFlows" && (
          <Suspense>
            <FormflowsWrapper spaceId={workspaceId} projectId={projectId} />
          </Suspense>
        )}
        {selected == "groups" && (
          <Suspense>
            <GroupsInSpace workspaceId={workspaceId} projectId={projectId} />
          </Suspense>
        )}
      </div>
    </div>
  );
}

export default Settings;
